export const dateSortComparator = (date1: string, date2: string): number => {
  const date1Timestamp = new Date(date1).getTime();
  const date2Timestamp = new Date(date2).getTime();

  if (date1Timestamp > date2Timestamp) return 1;
  if (date1Timestamp < date2Timestamp) return -1;
  return 0;
};
